(function() {
  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function toBoolean(value) {
    return value === 'true';
  }

  function initSection(section) {
    var carousel = section.querySelector('.carousel');
    if (!carousel || $(carousel).hasClass('slick-initialized')) return;

    var autoplay = toBoolean(section.dataset.autoplay);
    var autoplayMobile = toBoolean(section.dataset.autoplayMobile);
    var autoplaySpeed = toNumber(section.dataset.autoplaySpeed, 3000);
    var breakpointTablet = toNumber(section.dataset.breakpointTablet, 800);
    var prevArrow = section.querySelector('.custom-left-arrow');
    var nextArrow = section.querySelector('.custom-right-arrow');

    $(carousel).slick({
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      speed: 700,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        {
          breakpoint: breakpointTablet,
          settings: {
            autoplay: autoplayMobile,
            arrows: false,
            dots: true,
            speed: 200
          }
        }
      ]
    });
  }

  function whenSlickReady(callback, attempt) {
    var currentAttempt = attempt || 0;
    if (window.jQuery && $.fn && typeof $.fn.slick === 'function') {
      callback();
      return;
    }

    if (currentAttempt > 40) return;
    setTimeout(function() {
      whenSlickReady(callback, currentAttempt + 1);
    }, 150);
  }

  $(function() {
    whenSlickReady(function() {
      document
        .querySelectorAll('.anatomy[data-section-type="home-anatomy"]')
        .forEach(initSection);
    });
  });
})();
